import React, { useMemo } from 'react';

import { Radio } from '@mui/material';

// components
import AampeAccordion from '../../../components/shared/AampeAccordion/AampeAccordion';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';
// constants
import ICONS from '../../../constants/icons';

// models
import { FormulaSchedulingOptions } from '../../../models/formula.model';

interface FormulaDeliveryTypeContainerProps {
    title: string;
    isAutomated?: boolean;
    schedulingType: FormulaSchedulingOptions;
    value: FormulaSchedulingOptions;
    disabled?: boolean;
}

const FormulaDeliveryTypeContainer: React.FC<
    React.PropsWithChildren<FormulaDeliveryTypeContainerProps>
> = ({ title, children, isAutomated, schedulingType, value, disabled }) => {
    const sectionHeader = useMemo(() => {
        return (
            <TitleContainer>
                <RadioContainer
                    value={schedulingType}
                    checked={value === schedulingType}
                    onClick={(e) => e.stopPropagation()}
                    disabled={disabled}
                    color="default"
                />
                <TitleText>{title}</TitleText>
                {isAutomated && (
                    <ICONS.snippets color={aampeTheme.colors.success500} />
                )}
            </TitleContainer>
        );
    }, [title, value, schedulingType, disabled, isAutomated]);

    return (
        <Container>
            <StyledAampeAccordion title={sectionHeader}>
                <ChildContainer>{children}</ChildContainer>
            </StyledAampeAccordion>
        </Container>
    );
};

export default FormulaDeliveryTypeContainer;

const Container = styled.div({
    display: `flex`,
    flexDirection: `column`,
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
    padding: aampeTheme.spacing4(3, 2),
});

const RadioContainer = styled(Radio)(() => ({
    padding: aampeTheme.spacing4(2),
    '&.Mui-checked': {
        color: aampeTheme.colors.solidA01,
    },
}));

const TitleText = styled.span({
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
});

const TitleContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
});

const ChildContainer = styled.div({
    paddingLeft: aampeTheme.spacing4(12),
});

const StyledAampeAccordion = styled(AampeAccordion)(() => ({
    boxShadow: 'none !important',
    border: 'none !important',
}));
